import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouterModule } from '@angular/router'
import { PropertyPhotoGalleryModule } from '@components/property-photo-gallery/property-photo-gallery.module'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { SharedModule } from '../../shared/shared.module'
import { CreatePropertyComponent } from './create-property/create-property.component'
import { PropertiesComponent } from './properties.component'
import { propertiesRoutes } from './properties.routing'
import { PropertyContactsComponent } from './property-contacts/property-contacts.component'
import { PropertyDetailsComponent } from './property-details/property-details.component'
import { PropertyDocumentsComponent } from './property-documents/property-documents.component'
import { PropertyFeaturesComponent } from './property-features/property-features.component'
import { PropertyGalleryComponent } from './property-gallery/property-gallery.component'
import { PropertyMeasureComponent } from './property-measure/property-measure.component'
import { PropertyPaymentsComponent } from './property-payments/property-payments.component'
import { PropertyComponent } from './property/property.component'
import { PaymentCardModule } from '@components/payment-card/payment-card.module'
import { RadioModule } from '@components/radio/radio.module'
import { ContentLoadingModule } from '@components/content-loading/content-loading.module'
import { LngLatFieldsModule } from '@components/lng-lat-fields/lng-lat-fields.module'
import { PanelModule } from '@components/panel/panel.module'
import { TabsModule } from 'ngx-tabset'
import { TabsetModule } from '@components/tabset/tabset.module'
import { PropertyHistoryComponent } from './property-history/property-history.component'

@NgModule({
  declarations: [
    PropertiesComponent,
    PropertyDetailsComponent,
    PropertyFeaturesComponent,
    PropertyGalleryComponent,
    PropertyContactsComponent,
    PropertyMeasureComponent,
    CreatePropertyComponent,
    PropertyComponent,
    PropertyDocumentsComponent,
    PropertyPaymentsComponent,
    PropertyHistoryComponent,
  ],
  imports: [
    PanelModule,
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(propertiesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    SweetAlert2Module.forRoot(),
    SharedModule,
    PropertyPhotoGalleryModule,
    PaymentCardModule,
    RadioModule,
    ContentLoadingModule,
    LngLatFieldsModule,
    TabsetModule,
  ],
  exports: [PropertiesComponent, PropertyDetailsComponent],
})
export class PropertiesModule {}
